import React, { Component } from 'react';
import { PickerAddress } from '../../components/addressPicker';
import ChinaAreaSelectorPC from '../../template/ChinaAreaSelector/ChinaAreaSelectorPC';
// import ChinaAreaSelector from '../../template/ChinaAreaSelector/ChinaAreaSelector';
import UA from '../../utils/ua';
import { apiDefine } from '../../api/web';
import clientApi from "../../api/client";
import 'spring-picker/lib/style.css';
import './style.less';

class Adress extends Component {
    constructor(props){
        super(props);
        this.isMobile = UA.mobileClient;
        this.input = [];
        this.useraddress = props.defaultAddress ? props.defaultAddress : {};
        this.defaultAddress = 
        Boolean(this.useraddress.province) ? 
            [
                this.useraddress.province,
                this.useraddress.city,
                this.useraddress.area,
            ] 
            : 
            [];
        this.initAddress = UA.mobileClient ? ['北京市','北京市','东城区'] : ['北京市','东城区'];
        this.state = {
            name: this.useraddress.consignee,
            tele: this.useraddress.consigneePhone,
            addressDetail: this.useraddress.detail,
            address: this.defaultAddress.length ? this.defaultAddress : this.initAddress,
            addressPickerVisible: false,
            addressPickerVisiblePC: null,
        }
    }

    showAddressPicker (e) {
        e.nativeEvent.stopImmediatePropagation();
        if(this.isMobile){
            this.setState({addressPickerVisible: true});
        }
        else{
            this.setState({addressPickerVisiblePC: true});
        }
    }

    handleChangeAddress (address) {
        this.setState({address: address});
        this.defaultAddress = address;
    }

    closeAddressPicker (address) {
        this.setState({
            address: address,
            addressPickerVisible: false,
        });
    }

    cancelAddressPicker () {
        this.setState({
            address: this.defaultAddress,
            addressPickerVisible: false,
        });
    }

    handleReset = (type) => {
        this.setState({[type]:''});
    }

    onFocus = (type,e) => {
        this.setState({focusItem:type});
    }

    onChange = (type,e) => {
        const value = e.target.value;
        if(type === 'tele'){
            if(/\D+/.test(value)) return false;
        }
        this.setState({[type]:value});
    }
    onkeyUp = (e) => {
        // const value = e.target.value;
        // console.log(/^\d/.test(value))
    }
    addressPickerPC = value => {
        this.setState({address:value.names});
        this.defaultAddress = value.names;
    }
    onSave = () => {
        const errorMsg = [
            '收货人姓名需要在2-25个字符之间',
            '请输入正确的手机号码',
            '详细地址需要在5-120个字符之间',
        ];
        const addAddress = this.props.addAddress;
        let infoOk = [];
        infoOk = this.input.map((ele, index) => {
            const value = ele.value;
            if(index === 0){
                return value.length > 1 && value.length < 26 && !(/^\s/.test(value));
            }
            else if(index === 1){
                return (/^1[0-9]{10}$/.test(value));
            }
            else{
                return value.length > 4 && value.length < 121;
            }
        })
        let errorIndex = infoOk.indexOf(false);
        // if(errorIndex > -1) return alert(errorMsg[errorIndex]);
        // else if(!this.state.address.length) return alert('请填写城市');
        if(errorIndex > -1) return clientApi.alertView({
            title:'提示',
            content:errorMsg[errorIndex],
            confirm:'确定',
            cancel:'取消',
            id:'H5_1002'
        });
        else if(!this.state.address.length) return clientApi.alertView({
            title:'提示',
            content:'请选择省市区',
            confirm:'确定',
            cancel:'取消',
            id:'H5_1002'
        });
        else{
            const {
                name,
                tele,
                addressDetail,
                address
            } = this.state;
            addAddress({
                consignee: name,
                consigneePhone: tele,
                province: address[0],
                city: address[1],
                area: address[2],
                detail: addressDetail
            })
        }
    }
    testClick = (e)=>{
        const className = e.target.className;
        if(className.indexOf('container') !== -1){
            this.hideKeyboard();
            this.setState({focusItem: null})
        }
    }

    sendNotificationToH5 = (res) => {
        const { notification } = JSON.parse(res);
        console.log(notification)
        if(notification === 'hideKeyboard'){
            this.hideKeyboard()
        }
    }

    hideKeyboard = () =>{
        this.input.forEach( element => {
            element.blur()
        });
    }

    componentDidMount(){
        apiDefine({apiName:'sendNotificationToH5',fn:this.sendNotificationToH5}); // 定义客户端隐藏键盘方法
        // console.log(isNaN('a'))
    }
    render(){
        const {
            addressPickerVisible, 
            addressPickerVisiblePC,
            address,
            name,
            tele,
            addressDetail,
            focusItem
        } = this.state;
        // console.info({...this.state})
        return(
            <div className={`container address ${this.isMobile?'':'pc'}`} onClick={this.testClick} >
                <div className="form_wrap">
                    <ul>
                        <li className={name.length && focusItem === 'name' ? 'active' : ''}>
                            <div className="label">收货人</div>
                            <input 
                                type="text" 
                                placeholder="请输入真实姓名" 
                                id="name" 
                                ref={com=>{this.input[0] = com}} 
                                value={name}
                                onChange={this.onChange.bind(this,'name')}
                                onFocus={this.onFocus.bind(this,'name')}
                            />
                            <div className="after" onClick={this.handleReset.bind(this,'name')}>×</div>
                        </li>
                        <li className={tele.length && focusItem === 'tele'? 'active' : ''}>
                            <div className="label">手机号码</div>
                            <input 
                                type="text" 
                                placeholder="请输入手机号码" 
                                maxLength="11" id="tele" 
                                ref={com=>{this.input[1] = com}} 
                                value={tele}
                                onChange={this.onChange.bind(this,'tele')}
                                onKeyUp={this.onkeyUp.bind(this)}
                                onFocus={this.onFocus.bind(this,'tele')}
                            />
                            <div className="after" onClick={this.handleReset.bind(this,'tele')}>×</div>
                        </li>
                        <li>
                            <div className="label">所在地区</div>
                            {!this.defaultAddress.length ?
                                <div className="address_placeholder" onClick={this.showAddressPicker.bind(this)} >请选择省市区</div>
                                :
                                <div className={`address`} onClick={this.showAddressPicker.bind(this)} >{address.join(' ')}</div>
                            }
                        </li>
                        <li className={`address ${addressDetail.length && focusItem === 'addressDetail' ? 'active' : ''}`}>
                            <div className="label">详细地址</div>
                            <textarea 
                                placeholder="如道路、门牌号、小区、楼栋号、单元室等" 
                                ref={com=>{this.input[2] = com}} 
                                value={addressDetail}
                                onChange={this.onChange.bind(this,'addressDetail')}
                                onFocus={this.onFocus.bind(this,'addressDetail')}
                            ></textarea>
                            <div className="after" onClick={this.handleReset.bind(this,'addressDetail')}>×</div>
                        </li>
                    </ul>
                </div>
                <div className="btn save" onClick={this.onSave}>保存并使用</div>
                {this.isMobile &&
                    <PickerAddress
                        defaultValue={address}
                        onCancel={this.cancelAddressPicker.bind(this)}
                        onConfirm={this.closeAddressPicker.bind(this)}
                        visible={addressPickerVisible}
                        onChange={this.handleChangeAddress.bind(this)}
                    >
                    </PickerAddress>
                }
                {/* {this.isMobile &&
                    <ChinaAreaSelectorPC
                        defaultValue={address}
                        onChange={(value) => { console.info(value) }}
                    />
                } */}
                {(!this.isMobile && addressPickerVisiblePC) &&
                    <div className="address_picker_pc_wrap" onClick={()=>{this.setState({addressPickerVisiblePC:false})}}>
                        <div className="address_picker_pc" onClick={(e)=>{e.stopPropagation()}}>
                            <ChinaAreaSelectorPC
                                // defaultValue={address}
                                onChange={(value) => { this.addressPickerPC(value) }}
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default Adress;



// WEBPACK FOOTER //
// ./src/template/Address/Address.jsx